module.exports = __webpack_public_path__ + "media/images/Pays-black-logo-cb2fb723e1ade7b74bfd730f8d0b5140.svg";